import { render, staticRenderFns } from "./ButtonProgressAction.vue?vue&type=template&id=4970bf4a&scoped=true"
import script from "./ButtonProgressAction.vue?vue&type=script&lang=js"
export * from "./ButtonProgressAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4970bf4a",
  null
  
)

export default component.exports